import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter, Route, Routes, Navigate, useSearchParams, useNavigate} from "react-router-dom"
import {Toaster} from 'react-hot-toast'
import store from "./store"
import {Provider, useDispatch, useSelector} from "react-redux"
import {PersistGate} from 'redux-persist/integration/react'
import {persistStore} from 'redux-persist'

import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";

import {PrivateRoute} from './routes'

import SideBar from "./components/SideBar";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ChatSupport from "./pages/ChatSupport";
import Settings from "./pages/Settings"
import AiSupportChats from './pages/AiSupportChats/AiSupportChats'
import AiSupportSettings from './pages/AiSupportSettings/AiSupportSettings'
import RequireDepartmentAuth from "./hocs/RequireDepartmentAuth"
import { socket } from './socket';
import { telegramAuth, userSelector } from './store/slices/userSlice';

const persist = persistStore(store);

// Компонент для обробки Telegram авторизації
function TelegramAuthHandler() {
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuth, isSuccess } = useSelector(userSelector);

    useEffect(() => {
        const telegramHash = searchParams.get('telegramHash');

        console.log('telegramHash :>> ', telegramHash);
        
        if (telegramHash && !isAuth) {
            // Викликаємо Telegram авторизацію
            dispatch(telegramAuth(telegramHash));
        }
    }, [searchParams, dispatch, isAuth]);

    useEffect(() => {
        if (isSuccess && isAuth) {
            // Перенаправляємо на головну сторінку після успішної авторизації
            navigate('/chat-support', { replace: true });
        }
    }, [isSuccess, isAuth, navigate]);

    return null;
}

export default function App() {
    socket.connect();
    return (
        <BrowserRouter>
            <TelegramAuthHandler />
            <Routes>
                <Route
                 index
                    path="/"
                    element={
                        <RequireDepartmentAuth>
                            <Navigate to="/chat-support" replace/>
                        </RequireDepartmentAuth>
                    }
                />
                <Route element={<SideBar />}>
                    <Route path='/ai-support-chats' element={<PrivateRoute> <AiSupportChats /> </PrivateRoute>} />
                    <Route path='/ai-support-settings' element={<PrivateRoute> <AiSupportSettings /> </PrivateRoute>} />
                    <Route path='/settings' element={<PrivateRoute> <Settings /> </PrivateRoute>} />
                    <Route path='/chat-support' element={<PrivateRoute> <ChatSupport /> </PrivateRoute>} />
                </Route>
                <Route path='/registration' element={<SignUp />} />
                <Route path='/login' element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persist}>
            <App/>
            <Toaster/>
        </PersistGate>
    </Provider>
)